module.exports = __webpack_public_path__ + "static/media/cast-for-education-white-24dp.e1c75072.svg";